<!-- <div class="row gy-3"> -->
<!-- <div class="col-md-6 col-lg-12"> -->
<div class="product-card position-relative border p-3 cursor-pointer">
  <div class="d-flex flex-column">
    <div class="d-flex align-items-center mb-1">
      <h5 class="fw-500 mb-0">{{ craftEntity()?.code }}</h5>
      <span class="badge bg-secondary-subtle fw-500 ms-2 text-black">{{ CraftTypeEnum[craftEntity()?.type] }}</span>
      <button
        class="stretched-link px-2 btn btn-primary rounded-3 btn-sm d-flex align-items-center gap-2 btn-h35 ms-auto"
        (click)="openCraftModal.emit(craftEntity()?.id!)"
      >
        <i class="bi bi-plus-lg lh-1"></i>
        <span>Add</span>
      </button>
    </div>
    <p class="text-muted small mb-2">{{ craftEntity()?.description }}</p>
    <p class="text-muted small mb-0">{{ craftEntity()?.task?.taskCode }}</p>
  </div>
</div>
